module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAjCAYAAAD48HgdAAABSklEQVR4Ae2WJVB9cRSE799dcHfog2VcesClJ1waEvFMw6XPoImIU5GMFNzlsHdmcX1uv2/ma3v2vetHew4RaYUfNAui98NmQ4d0euBXC/2pr7AbiqGDV1BnFP4285/6zV6dK0OHC+Eph2egl5n+lBf7hP3FxpRkwgOWrMAIE/9UBHuEvZmmlMXDLZZtwBgje2I4L+yLN8fpj4JrLN2FaQbOp3JO2BNlzhvWF87fuzdy3zmXzbxw3tcSj/g/OAF1rmDZG/lS5oRz/zRLwffPICQS9OJBEOb5PrT8G7sd6oS+kPkPdTrgR82aiEg1DHnljNVqNkFhwHbBjB+sf8Vwm2wXLJ6S51mCn2y2XfBTcylPSbTpdsFspxAybPPtgjlvuMPcEQy1i+2CuXJmGu1mu2DmC5yEv+xru+CfU9uF2i7UdqFQKBRWROyUayN6+Xqkv8kpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn-scroll.png
// module id = 391
// module chunks = 1